import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import './noticeToast.scss';
import { logEvent } from '@src/reactGa';

interface props {
    hasMark?: boolean; // N아이콘 표시 여부
    notice: string;
    btnName?: string;
    linkUrl?:string;
    bottom?: number; // bottom으로부터 떨어져있는 거리 (기본: 20px)
}

const NoticeToast = ({ hasMark=true, notice, btnName='확인', linkUrl='',bottom = 20}:props) => {
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState<boolean>((notice !==''))
    const clickBtn = () => {
			logEvent("notice", {
				component: "toast",
				behavior: "click",
				title: notice,
				page_path: window.location.pathname
			})
			setShowToast(false)
			if(linkUrl !== ''){
				navigate(linkUrl)
			}
    }
    return (
        <>
        {showToast && (
            <div className='partner-bottom-notice-wrap' style={{bottom: bottom}}>
                <div className="notice-alert">
                    {hasMark && <div className="new-mark ttnorms-bold">N</div>}
                    <p className="text">{notice}</p>
                     <button className="close-btn" onClick={clickBtn}>
                        {btnName}
                    </button>
                </div>
            </div>
        )}
        </>
    );
};

export default NoticeToast;